(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/logout/views/logout.js') >= 0) return;  svs.modules.push('/modules/logout/views/logout.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.logout=_svs.logout||{};
_svs.logout.templates=_svs.logout.templates||{};
svs.logout.templates.logout = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"logout-view\" class=\"js-logout-view logout-view logout-view-vh bg-logout-transparent\">\n  <div class=\"js-logout-view-container\">\n    <div class=\"js-logout-view-loader logout-view-loader\"></div>\n    <p class=\"h3 f-content\">Loggar ut, var god vänta...</p>\n  </div>\n  <iframe\n    class=\"hide\"\n    id=\"iam-logout-iframe\">\n  </iframe>\n</div>\n";
},"useData":true});
Handlebars.partials['svs-logout-logout'] = svs.logout.templates.logout;
})(svs, Handlebars);


 })(window);